// 组件对象，大写
import fMSuperSearchModal from './fMSuperSearchModal.vue'
export default fMSuperSearchModal
